<div class="clasificator">
  <div class="toggle">
    <div class="toggle-left" [attr.aria-expanded]="!isCollapsed" (click)="toggleCollapse()"
      (keydown.enter)="toggleCollapse()" tabindex="1" aria-controls="collapse">
      <img [ngClass]="{ chevron: true, open: !isCollapsed }" src="assets/images/chevron-icon.svg" alt="arrow" />
      <h5 class="group-title">{{ classifier.name }}</h5>
      <span class="size">{{ classifier.count }}</span>
    </div>
    @if (allowedToModify(classifier)){
      <div class="actions">
        <app-add-classifier-value [classifier]="classifier" [isLoading]="isClassifierCrudLoading"
          [siblingValues]="classifierValues" [policyType]="CLAIM_SCOPE" [claimType]="CLAIM_TYPES['create']"
          (save)="onAddClassifierValue($event)" appPermission />
        <app-edit-classifier [classifier]="classifier" [isLoading]="isClassifierCrudLoading" [policyType]="CLAIM_SCOPE"
          [claimType]="CLAIM_TYPES['update']" (save)="onClassifierEdit($event)" appPermission />
      </div>
    }
  </div>
  <div id="collapseExample" [ngbCollapse]="isCollapsed">
    @if (haveValuesLoaded) {
      @for (value of classifierValues; track value.name) {
        <div class="item-wrapper">
          <div class="item">
            <p class="item-name">{{ value.name }}</p>
              @if (allowedToModify(classifier)){
                <div class="item-actions">
                  @if (!isDeleteRestricted(value)) {
                    <app-delete-classifier-value [value]="value" [isLoading]="isClassifierCrudLoading" [policyType]="CLAIM_SCOPE"
                      [claimType]="CLAIM_TYPES['delete']" (save)="deleteClassifierValue($event)" appPermission />
                  }
                  <app-edit-classifier-value [value]="value" [isLoading]="isClassifierCrudLoading"
                    [siblingValues]="classifierValues" [policyType]="CLAIM_SCOPE" [claimType]="CLAIM_TYPES['update']"
                    (save)="editClassifierValue($event)" appPermission />
                </div>
              }
          </div>
        </div>
      }
    } @else {
     <app-spinner [isLoading]="!haveValuesLoaded" />
    }
  </div>
</div>
